import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, Twitter, Instagram, Facebook, Disc as Discord } from 'lucide-react';
import { AppBadge } from './ui';
export const Footer = () => {
  return <footer className="bg-[#020408] border-t border-white/10 pt-20 pb-10 relative overflow-hidden" data-id="element-35">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-purple-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-36"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-37">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16" data-id="element-38">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-39">
            <Link to="/" className="flex items-center mb-6" data-id="element-40">
              <span className="text-xl font-extrabold tracking-tight text-white" data-id="element-41">
                KDX
              </span>
            </Link>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed" data-id="element-42">
              Your all-in-one digital marketplace for gaming top-ups, gift
              cards, utility payments, and everyday digital purchases.
            </p>
            <div className="flex items-center gap-4" data-id="element-43">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-44">
                <Twitter className="w-5 h-5" data-id="element-45" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-46">
                <Instagram className="w-5 h-5" data-id="element-47" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-48">
                <Facebook className="w-5 h-5" data-id="element-49" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-50">
                <Discord className="w-5 h-5" data-id="element-51" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div data-id="element-52">
            <h3 className="text-white font-semibold mb-6" data-id="element-53">Product</h3>
            <ul className="space-y-3 text-sm" data-id="element-54">
              <li data-id="element-55">
                <Link to="/" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-56">
                  Home
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/#features" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-58">
                  Features
                </Link>
              </li>
              <li data-id="element-59">
                <Link to="/#marketplace" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-60">
                  Marketplace
                </Link>
              </li>
              <li data-id="element-61">
                <Link to="/#wallet" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-62">
                  Wallet
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/#rewards" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-64">
                  Rewards
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/#download" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-66">
                  Download
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-67">
            <h3 className="text-white font-semibold mb-6" data-id="element-68">Support</h3>
            <ul className="space-y-3 text-sm" data-id="element-69">
              <li data-id="element-70">
                <Link to="/support" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-71">
                  Help Center
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-73">
                  Contact Support
                </Link>
              </li>
              <li data-id="element-74">
                <Link to="/faq" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-75">
                  FAQs
                </Link>
              </li>
              <li data-id="element-76">
                <Link to="/support#orders" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-77">
                  Order Help
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/support#refunds" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-79">
                  Refunds
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-80">
            <h3 className="text-white font-semibold mb-6" data-id="element-81">Legal</h3>
            <ul className="space-y-3 text-sm" data-id="element-82">
              <li data-id="element-83">
                <Link to="/terms" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-84">
                  Terms and Conditions
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/legal-terms" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-86">
                  Legal Terms of Use
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/privacy" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-88">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/cookies" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-90">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/privacy-choices" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-92">
                  Your Privacy Choices
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/code-of-conduct" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-94">
                  Code of Conduct
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="/rewards-rules" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-96">
                  Rules and Rewards
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-97">
            <h3 className="text-white font-semibold mb-6" data-id="element-98">Company</h3>
            <ul className="space-y-3 text-sm" data-id="element-99">
              <li data-id="element-100">
                <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-101">
                  About
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-103">
                  Contact
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-105">
                  Careers
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-107">
                  Press
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-108">
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-109">
            <p className="text-gray-500 text-sm" data-id="element-110">
              Copyright © 2026 KDX. All rights reserved.
            </p>
            <p className="text-gray-600 text-xs" data-id="element-111">
              By using KDX, you agree to our{' '}
              <Link to="/terms" className="hover:text-gray-400 underline" data-id="element-112">
                Terms
              </Link>{' '}
              and{' '}
              <Link to="/privacy" className="hover:text-gray-400 underline" data-id="element-113">
                Privacy Policy
              </Link>
              .
            </p>
          </div>

          <div className="flex items-center gap-3" data-id="element-114">
            <img src="https://cdn.magicpatterns.com/uploads/2QggovsFyamyAJVaf1LK9c/app-store-google-play-logo-png_seeklogo-370449.png" alt="Download on App Store and Google Play" className="h-10 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity" data-id="element-115" />
          </div>
        </div>
      </div>
    </footer>;
};